import * as React from 'react';

import logger from 'js/app/loggerSingleton';

import PartnerList from 'bundles/browse-common/components/PartnerList';
import { usePartnerList } from 'bundles/browse-common/contexts/PartnerListContext';
import { usePageConfigComponentTrackingData } from 'bundles/page-config-common/contexts/PageConfigComponentMetadataContext';

const TopPartnersComponentRenderer = () => {
  const partnerListContext = usePartnerList();

  const pageConfigComponentTrackingData = usePageConfigComponentTrackingData();

  if (!partnerListContext) {
    logger.warn('TopPartnersComponentRenderer expected PartnerListContext');
    return null;
  }

  const { partners } = partnerListContext;

  return <PartnerList partners={partners || []} pageConfigComponentTrackingData={pageConfigComponentTrackingData} />;
};

export default TopPartnersComponentRenderer;
